// extracted by mini-css-extract-plugin
module.exports = {"container":"DepartureHeader_container__T_QOj","header-wrapper":"DepartureHeader_header-wrapper__6vcR3"};